<script>
  import { _ } from "svelte-i18n"
	import { modals, user, hero_expanded } from '../stores'
  import { sendPageViewToAnalytics } from '../modules/helpers'
  import UAParser from 'ua-parser-js'
  import Button from '../elements/Button.svelte'
  import ProfileDropdown from "./ProfileDropdown.svelte"

  function openBuy() {
    modals.open('buy')
    if (typeof window.gtag == "undefined") return
    gtag('event', 'buy_modal_shown', {
      'initiator': 'header_nav'
    });
  }

  function openFeatures() {
    modals.open('features')
    sendPageViewToAnalytics('Features', 'https://wordmark.it/features')
  }

</script>

<div class="HeaderNav" class:hero_expanded={$hero_expanded}>
  <a href="/help/" target="_blank" class="hideMobile">{$_('navigation.help')}</a>
  <a href="/contact/" target="_blank" class="hideMobile">{$_('navigation.contact')}</a>
  {#if $user === undefined}
    <span class="hideMobile buttonWrapper">
      <Button kind="transparent" on_fill={true} on:click={openFeatures}>
        {$_('navigation.features')}
      </Button>
    </span>
    <span class="hideMobile buttonWrapper">
      <Button kind="transparent" on_fill={true} href="https://chromewebstore.google.com/detail/wordmarkit-extension/plafaneablgcojpbaeefkmnheilloopl?hl=en" target="_blank">
        {$_('navigation.extension')}
      </Button>
    </span>
    <Button kind="outline" on_fill={true} on:click={() => modals.open('login')}>
      {$_('buttons.login')}
    </Button>
    <Button kind="accent-orange" on_fill={true} on:click={openBuy}>
      {@html $_('buttons.plansAndPricing')}
    </Button>
  {:else}
    <ProfileDropdown/>
  {/if}
</div>

<style>
  .HeaderNav > :global(button) {
    margin-left: 1rem;
  }
  .HeaderNav > a,
  .HeaderNav > .buttonWrapper {
    margin: 0 1rem;
  }
  .HeaderNav > :global(.dropdown > button) {
    margin-left: 1rem;
  }

  .HeaderNav > a {
    text-decoration: none;
    font-family: var(--PensumSans);
    font-weight: 500;
    letter-spacing: 0.05rem;
    color: var(--c-text-on-fill);
    transition: color var(--transition-props);
  }
  .HeaderNav > a:hover {
    color: var(--c-text-on-fill-hover);
  }

  @media only screen and (max-width: 870px) {
    .HeaderNav:not(.hero_expanded) {
      display: none;
    }
  }

  @media only screen and (max-width: 640px) {
    .hideMobile {
      display: none;
    }
  }
</style>